/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, LazyloadService, PermissionService, PromptService, TimeService, ToastService, UtilService } from '@dm/core';
import { AuthService, ToolService } from 'app/common/services';

import { GuideStorageKey } from '../../smart-assistant/smart-assistant.const';
import { SmartAssistantService } from '../../smart-assistant/smart-assistant.service';
import { ExportComponent } from '../export/export.component';
import { type ExpansionBoard } from '../export/export.enum';
import { ExportService } from '../export/export.service';
import { ExportStrService } from '../export/export-str.service';

@Component({
    selector: 'app-export-simple',
    templateUrl: './export-simple.component.html',
    styleUrls: ['../export/export.component.scss'],
})
export class ExportSimpleComponent extends ExportComponent {
    /**
     * 是否为极简设置入口
     */
    @Input() isSimpleSettingsEntrance = false;

    icon = {
        success: '#core-icon-simple-status-succeed',
        failed: '#core-icon-simple-status-failed',
    };

    constructor(
        public toast: ToastService,
        public prompt: PromptService,
        public str: ExportStrService,
        public exportService: ExportService,
        public lazyLoadSerevice: LazyloadService,
        public fb: FormBuilder,
        public authService: AuthService,
        public router: Router,
        public permissionService: PermissionService,
        public timeService: TimeService,
        public utilService: UtilService,
        public toolService: ToolService,
        private smartAssistantService: SmartAssistantService,

    ) {
        super(toast, prompt, str, exportService, lazyLoadSerevice, fb, authService, router,
            permissionService, timeService, utilService, toolService);
    }

    /**
     * 关闭回调（极简模式需要与智能助手联动）
     */
    onClose(): void {
        if (this.isSimpleSettingsEntrance) {
            super.onClose();
            return;
        }
        if (this.checkExistEmporting()) {
            this.prompt.promptConfirm({
                title: this.i18n.title,
                content: this.i18n.confirmMsg,
                onOk: () => {
                    this.prompt.close();
                    this.smartAssistantService.setGuideConfig(GuideStorageKey.showSmartAssistant, false, false);
                    this.smartAssistantService.setGuideConfig(GuideStorageKey.showExportLog, false);
                },
            });
        } else {
            this.smartAssistantService.setGuideConfig(GuideStorageKey.showSmartAssistant, false, false);
            this.smartAssistantService.setGuideConfig(GuideStorageKey.showExportLog, false);
        }
    }

    /**
     * 拼接日志项的导出大小与导出时长Tip
     */
    getTip(nodeList: Array<ExpansionBoard | Controller>): void {
        Object.keys(this.str.btnTipConfig).forEach((item: string) => {
            if (this.btnMap[item]) {
                this.btnMap[item].time = this.i18n.aboutTime(this.getTimeTip(item).toString());
                this.btnMap[item].size = this.i18n.aboutSize(this.getSizeTip(item, nodeList).toString());
            }
        });
    }
}
